import { useOverlaysControls } from 'features/siteMap/tilesetMap/OverlaysHandler'
import React, { ReactNode } from 'react'
import { Vector3 } from 'three'

import { Label } from './Label'

export const TilesetMapFeatureLabel: React.FC<{
  body: ReactNode
  hovered?: boolean
  position?: Vector3
  name?: string
  visible: boolean
}> = ({ position, hovered = false, body, name, visible }) => {
  const { showLabels } = useOverlaysControls()
  return !showLabels && !hovered ? null : (
    <Label body={body} position={position} name={name} visible={visible} />
  )
}
